/**
 * i18n phase: customer brand page + discovery + brand coupons.
 * Tuples are [ko, en, vi, ru].
 */

function pick(obj, langIndex) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  }
  return out;
}

const brandPage = {
  discoveryLabel: ['브랜드', 'Brands', 'Thương hiệu', 'Бренды'],
  recommendedTitle: ['추천 메뉴', 'Recommended', 'Gợi ý', 'Рекомендуем'],
  fromPrice: ['{price}부터', 'From {price}', 'Từ {price}', 'От {price}'],
  viewAllStores: ['전체 가게 보기 {count}', 'View all stores ({count})', 'Xem tất cả cửa hàng ({count})', 'Все магазины ({count})'],
  nearbyTitle: ['가까운 가게', 'Nearby stores', 'Cửa hàng gần đây', 'Рядом'],
  tabDelivery: ['배달', 'Delivery', 'Giao hàng', 'Доставка'],
  tabPickup: ['픽업', 'Pickup', 'Nhận tại quán', 'Самовывоз'],
  noStores: ['해당하는 가게가 없습니다', 'No matching stores', 'Không có cửa hàng phù hợp', 'Нет подходящих магазинов'],
  notFound: ['브랜드를 찾을 수 없습니다', 'Brand not found', 'Không tìm thấy thương hiệu', 'Бренд не найден'],
  errorGeneric: ['불러오기에 실패했습니다', 'Failed to load', 'Không tải được', 'Не удалось загрузить'],
  minOrder: ['최소주문', 'Min. order', 'Đơn tối thiểu', 'Мин. заказ'],
  badgeDelivery: ['배달가능', 'Delivery', 'Giao hàng', 'Доставка'],
  badgePickup: ['픽업가능', 'Pickup', 'Nhận tại quán', 'Самовывоз'],
  badgeKorean: ['한국어', 'Korean', 'Tiếng Hàn', 'Корейский'],
  brandBadge: ['브랜드', 'Brand', 'TH', 'Бренд'],
  franchiseBadgeHint: ['체인/프랜차이즈', 'Chain / franchise', 'Chuỗi/nhượng quyền', 'Сеть/франшиза'],
  couponsTitle: ['쿠폰', 'Coupons', 'Phiếu giảm giá', 'Купоны'],
  couponPercent: ['{n}% 할인', '{n}% off', 'Giảm {n}%', 'Скидка {n}%'],
  couponAmount: ['{n} 할인', '{n} off', 'Giảm {n}', 'Скидка {n}'],
  couponShipping: ['배달비 무료', 'Free delivery', 'Miễn phí giao hàng', 'Бесплатная доставка'],
  couponGift: ['증정', 'Gift', 'Quà tặng', 'Подарок'],
  couponGeneric: ['쿠폰', 'Coupon', 'Phiếu', 'Купон'],
  claimBtn: ['받기', 'Claim', 'Nhận', 'Получить'],
  claimedBtn: ['받았어요', 'Claimed', 'Đã nhận', 'Получено'],
  claimSuccess: ['쿠폰을 받았어요', 'Coupon claimed', 'Đã nhận phiếu', 'Купон получен'],
  claimError: ['쿠폰을 받을 수 없습니다', 'Could not claim coupon', 'Không nhận được phiếu', 'Не удалось получить купон'],
  claim_already_claimed: ['이미 받은 쿠폰이에요', 'Already claimed', 'Đã nhận rồi', 'Уже получено'],
  claim_coupon_expired: ['만료된 쿠폰이에요', 'Coupon expired', 'Phiếu đã hết hạn', 'Срок истёк'],
  claim_coupon_sold_out: ['쿠폰이 소진되었어요', 'Sold out', 'Đã hết phiếu', 'Закончились'],
  claim_coupon_inactive: ['사용할 수 없는 쿠폰이에요', 'Coupon inactive', 'Phiếu không khả dụng', 'Купон недоступен'],
  claim_not_authenticated: ['로그인이 필요합니다', 'Please sign in', 'Cần đăng nhập', 'Войдите'],
  couponIssueBtn: ['지점 전체에 쿠폰 발행', 'Issue coupon to all branches', 'Phát phiếu cho mọi chi nhánh', 'Купон на все филиалы'],
  couponIssuedToast: [
    '{count}개 지점에 쿠폰을 발행했어요',
    'Issued coupon to {count} branches',
    'Đã phát phiếu cho {count} chi nhánh',
    'Купон выдан в {count} филиалах',
  ],
};

function buildLang(langIndex) {
  return { brandPage: pick(brandPage, langIndex) };
}

export const phaseBrandPageKo = buildLang(0);
export const phaseBrandPageEn = buildLang(1);
export const phaseBrandPageVi = buildLang(2);
export const phaseBrandPageRu = buildLang(3);
